import React, { useState } from "react";
import "./ModalUsdt.scss";
import { useNavigate } from "react-router-dom";

const ModalUSDT = ({ isOpen, onClose, amount, depositData }) => {
  const [selectedMethod, setSelectedMethod] = useState("USDT-TRC20");
  const navigate = useNavigate();
  if (!isOpen) return null;

  const address = depositData?.walletAddress || "TBaV2R1hubhG3VnX4vZ6ZgiCV6HPZMBDqu";
  const rate = depositData?.rate || 26290;

  const handleCopy = () => {
    navigator.clipboard.writeText(address);
    alert("Sao chép thành công");
  };

  return (
    <div className="modalusdt-overlay">
      <div className="modalusdt-container">
        <p className="modalusdt-title">Số tiền nạp: {amount} USDT</p>
        <p className="modalusdt-title1">
          Tỷ giá: <span style={{ color: "red" }}>{rate.toLocaleString()}</span>, THB:{" "}
          <span style={{ color: "red" }}>
            {(rate * amount).toLocaleString("vi-VN")}
          </span>
        </p>

        <div className="modalusdt-radio-group">
          <label
            className={`modalusdt-radio ${
              selectedMethod === "USDT-TRC20" ? "modalusdt-checked" : ""
            }`}
          >
            <input
              type="radio"
              value="USDT-TRC20"
              checked={selectedMethod === "USDT-TRC20"}
              onChange={() => setSelectedMethod("USDT-TRC20")}
            />
            USDT-TRC20
          </label>
        </div>

        <div className="modalusdt-payee-item">
          <div className="modalusdt-payee-img">
            <img
              src={"./bankusdt.jpg"}
              alt="QR"
            />
          </div>
          <div className="modalusdt-payee-content">
            <div>Địa chỉ nạp tiền:</div>
            <div className="modalusdt-address">{address}</div>
            <div className="modalusdt-note modalusdt-red">
              Ghi chú: vui lòng điền đúng ID giao dịch và cung cấp đúng ảnh giao dịch thành công
            </div>
            <div className="modalusdt-buttons">
              <button className="modalusdt-actions" onClick={handleCopy}>
                Sao chép địa chỉ
              </button>
              <button onClick={() => navigate("/lichsunaprutmobile")}>
                Đi đến lịch sử
              </button>
            </div>
          </div>
        </div>

        <button className="modalusdt-close-btn" onClick={onClose}>
          Đóng
        </button>
      </div>
    </div>
  );
};

export default ModalUSDT;
